module.exports = __webpack_public_path__ + "img/news4-1.04f6c242.png";